import { useState } from "react";
import OtpInput from "react-otp-input";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Tickimg from "../../../../../assets/images/sign-up/checked.png";
import ApiClient from "helpers/ApiClient";
import "../../../../../scss/common.scss";
import "./OtpVerification.scss";
import { Button } from "@mui/material";

export default function OtpVerification({ nextStepHandler, onCancel, setToggleSnackbar, email }: any) {
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");
  const [accountVerifed, setAccountVerifed] = useState(false);

  const handleChange = (code: any) => {
    setCode(code);
    setError(false);
    setErrorMessage("");
  };
  
  const verifyCode = () => {
    if (code.length < 6) {
      setError(true);
      setErrorMessage("Enter the 6-digit verification code");
    } else {
      setLoading(true);
      ApiClient
        .post("users/confirm", { email, code })
        .then(() => {
          setAccountVerifed(true);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          let err = error.response.data.message.slice(0, 7);
          if (err === "Invalid") {
            setError(true);
            setErrorMessage("Invalid Code");
          } else {
            setToggleSnackbar({
              message: error.response.data.message,
              isToggle: true,
              mode: "error",
              top: "110px",
            });
          }
        });
    }
  };

  const ResendCode = () => {
    setCode("");
    ApiClient
      .post("users/resend-code", { email })
      .then(() => {
        setToggleSnackbar({
          message: "OTP code resent to registered email.",
          isToggle: true,
          mode: "success",
          top: "110px",
        });
      })
      .catch((err) => {
        const error = err.response.data.message;
        setToggleSnackbar({
          message: error,
          isToggle: true,
          mode: "error",
          top: "110px",
        });
      });
  };

  return (
    <Box className="otp-wraper">
      <Box className="Otp_App">
        <h1 className="AccountVerf fw-500 grey-color fs-24 ">Account Verification</h1>
        {accountVerifed ? (
          <div className="VerifedMessage">
            <h4 className="secondary-color fs-28">Congratulations</h4>
            <img src={Tickimg} alt="Verfied" />
            <p className="grey-color fs-16 ">Your account has been verified</p>
            <Button
              className="btn-primary"
              onClick={nextStepHandler}
              sx={{
                width: { xs: "90%", sm: "40%" },
                textTransform: "capitalize",
                fontSize: "16px",
                fontWeight: 700,
              }}
            >
              Continue
            </Button>
          </div>
        ) : (
          <>
            <p className="completeProcess">
              Please enter the 6 digit verification code sent on your email to complete signup
              process
            </p>
            <div className="OtpVerification">
              <OtpInput
                value={code}
                onChange={handleChange}
                numInputs={6}
                separator={<span style={{ width: "13px" }}></span>}
                isInputNum={true}
                shouldAutoFocus={true}
                className="otp-input"
                errorStyle={{
                  border: "1px solid red",
                }}
                hasErrored={error ? true : false}
              />
            </div>

            {error && (
              <p className="ErrorMessage error-color" style={{ marginTop: "3px" }}>
                {errorMessage}
              </p>
            )}

            {loading ? (
              <Box sx={{ display: "flex" }}>
                <CircularProgress size="6rem" className="OtpProgress" />
              </Box>
            ) : (
              <>
                <div>
                  <p className="ResendCode">
                    Didn’t receive the verification code?
                    <br />
                    <a onClick={ResendCode} className="secondary-color cursor-pointer">
                      Resend Code
                    </a>
                  </p>
                </div>
                <div className="stepperBtn">
                  <button type="button" className="btn-white fs-16 fw-700" onClick={() => onCancel?.()}>
                    Cancel
                  </button>
                  <Button variant="contained" onClick={verifyCode} className="btn-primary">
                    Verify
                  </Button>
                </div>
              </>
            )}
          </>
        )}
      </Box>
    </Box>
  );
}
